module.exports = __webpack_public_path__ + "static/media/Noemi_Rodriguez_Vega.303f16aa.png";